import { getTargetLanguage, LANG_EN, LANG_FR } from '../util/language_v3'

export const toggleLanguage = () => {
    return {
        type: "TOGGLE_LANGUAGE",
    }
}

export const setLanguage = (lang) => {
    return {
        type: "SET_LANGUAGE",
        language: lang,
    }
}
